import { LoadingButton } from '@mui/lab'
import { Button, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNotify, useTranslate } from 'react-admin'
import { itemServices } from 'src/services/reservation/item/item.service'

export const BillingNumberDialog = ({setBillingNumberModal, itemIdToEdit, setReloadItemsToBill}) => {
    const translate = useTranslate()
    const notify = useNotify()
    const [billingNumber, setBillingNumber] = useState(0)
    const [isLoading, setIsLoading] = useState(false)

    const updateErpId = async () =>{
        setIsLoading(true)
        await itemServices.updateErpId(itemIdToEdit, billingNumber).then(()=>{
            notify('ra.notification.updated_success_masculine', {type:'success', messageArgs:{element:'item'}})
            setBillingNumberModal(false)
            setReloadItemsToBill(reload=>!reload)
        }).catch(()=>{
            notify('ra.notification.updated_error_masculine', {type:'error', messageArgs:{element:'item'}})
        }).finally(()=>{
            setIsLoading(false)
        })
    }


  return (
    <div>
        <TextField
            type='number'
            fullWidth
            value={billingNumber}
            style={{marginBottom:'15px'}}
            onChange={(val)=>setBillingNumber(val.target.value)}
        />
        <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
            <Button
                color='error'
                variant='contained'
                onClick={() => {
                    setBillingNumberModal(false)
                }}
                autoFocus
                >
                {translate('ra.action.cancel')}
            </Button>

            <LoadingButton
                variant='contained'
                onClick={() => {updateErpId()}}
                loading={isLoading}
                disabled={isLoading}
            >
                {translate('ra.action.confirm')}
            </LoadingButton>
        </div>
    </div>
  )
}
